<template>
    <div class="my-report-page">
        <!-- 1、title -->
        <div class="home-title-bar report-title-bar strong-report-title-bar dsp-flex">
            <div class="home-title-side home-title-side-left" @click="clickBack"><i class="iconfont icon-guanbi"></i></div>
            <div class="home-title-mid"><span class="home-title-title">我的报告</span></div>
            <div class="home-title-side"></div>
        </div>
        <!-- 2、报告记录列表 -->
        <my-report-list 
            v-bind:gotData="gotRecordData" 
            v-bind:recordList="recordListData">
        </my-report-list>

        <no-data
            v-if="noRecordData"
            :class="'strong-no-data'"
            v-bind:noteText="'记录空空如也~'"
            v-bind:showButton="true"
            v-bind:buttonText="'马上测测'"
            v-bind:buttonFunc="clickStartReport">
        </no-data>

        <!-- 3、底部背景 -->
        <div class="my-report-page-bottom"></div>
    </div>
</template>

<script>
import NoData from '../../components/common/NoData.vue'
import MyReportList from '../../layouts/strong/MyReportList.vue'
import * as doctitle from '../../modules/data/base/doctitle'
import { DOM } from '../../modules/dom';
export default {
    name: 'MyReport',
    components: { NoData, MyReportList },
    computed: {
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        gotRecordRecentlyData() {
            return this.$store.state.record.gotRecordRecentlyData;
        },
        recordListData() {
            return this.$store.state.record.recordListData;
        },
        noRecordData() {
            return this.$store.state.record.noRecordData;
        },
    },
    created() {
        if(!this.gotRecordRecentlyData){
            this.$store.dispatch('record/initRecordRecentlyList');
            setTimeout(() => {
                this.initDom();
            }, 1000);
            DOM.setDocumentTitle(doctitle.TITLE_STRONG);
        }
    },
    mounted() {
        DOM.setDocumentTitle(doctitle.TITLE_STRONG);
        setTimeout(() => {
            this.initDom();
            this.$store.dispatch('initBasicData');
            // 加载完成后,静默加载全部列表数据
            if(!this.gotRecordData){
                this.$store.dispatch('record/initRecordList');
                this.$router.replace('/strong');
            }
        }, 20);
        setTimeout(() => {
            this.$store.dispatch('record/filterOtherRecordList', {
                type: 'recent',
                value: 0
            });
        }, 300);
    },
    methods: {
        initDom() {
            var rootDom = document.getElementsByClassName('wrapper')[0];
            this.$el.style.width = rootDom.clientWidth + 'px';
            this.$el.style.minHeight = innerHeight + 'px';
            // this.$el.style.overflow = 'hidden';

            var me = this;
            window.onresize = function() {
                me.$el.style.width = rootDom.clientWidth + 'px';
                me.$el.style.minHeight = innerHeight + 'px';
                // me.$el.style.overflow = 'hidden';
            }
        },
        clickBack() {
            this.$router.replace('/strong');
        },
        clickStartReport() {
            this.$router.replace('/strong');
        }
    }
}
</script>
